import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "event-scanner" }
const _hoisted_2 = { class: "ds-panel ds-panel--space_lg" }
const _hoisted_3 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_4 = { class: "ds-caption ds-caption--size_lg ds-caption--weight_semi-bold ds-caption--appearance_center ds-caption--color_white" }
const _hoisted_5 = {
  key: 0,
  class: "ds-panel ds-panel--space_xl"
}
const _hoisted_6 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_7 = { class: "ds-caption ds-caption--appearance_center ds-caption--color_white" }
const _hoisted_8 = {
  key: 1,
  class: "ds-panel ds-panel--space_xl"
}
const _hoisted_9 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_10 = { class: "ds-caption ds-caption--appearance_center ds-caption--color_white" }
const _hoisted_11 = { class: "ds-panel ds-panel--space_lg" }
const _hoisted_12 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_13 = { class: "g-row g-row--justify_center" }
const _hoisted_14 = { class: "g-cell" }
const _hoisted_15 = {
  key: 2,
  class: "ds-panel ds-panel--space_md"
}
const _hoisted_16 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_17 = { class: "g-row g-row--justify_center" }
const _hoisted_18 = { class: "g-cell" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ds-panel ds-panel--space_md" }
const _hoisted_21 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_22 = { class: "g-row g-row--justify_center g-row--space_md" }
const _hoisted_23 = {
  key: 0,
  class: "g-cell"
}
const _hoisted_24 = {
  key: 1,
  class: "g-cell"
}
const _hoisted_25 = { class: "event-scanner__zoom" }
const _hoisted_26 = { class: "event-scanner__zoom-label" }
const _hoisted_27 = ["min", "max", "step"]
const _hoisted_28 = { class: "event-scanner__overlay-inner" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "event-scanner__icon" }, "✓", -1)
const _hoisted_30 = { class: "event-scanner__headline" }
const _hoisted_31 = {
  key: 0,
  class: "event-scanner__name"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "event-scanner__icon" }, "⚠", -1)
const _hoisted_33 = { class: "event-scanner__headline" }
const _hoisted_34 = {
  key: 0,
  class: "event-scanner__name"
}
const _hoisted_35 = {
  key: 1,
  class: "event-scanner__note"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "event-scanner__icon" }, "✗", -1)
const _hoisted_37 = { class: "event-scanner__headline" }
const _hoisted_38 = {
  key: 0,
  class: "event-scanner__note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_button = _resolveComponent("control-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($props.eventTitle), 1)
      ])
    ]),
    _createElementVNode("div", { class: "event-scanner__viewport" }, [
      _createElementVNode("div", { id: $setup.readerElementId })
    ]),
    (!$setup.cameraStarted && !$setup.cameraError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.$t("Запуск камери...")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.cameraError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.cameraError), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_control_button, {
                      onClick: _withModifiers($setup.startScanner, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.$t("Спробувати ще раз")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.cameras.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  class: "event-scanner__camera-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedCameraId) = $event)),
                  onChange: $setup.switchCamera
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cameras, (camera) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: camera.id,
                      value: camera.id
                    }, _toDisplayString(camera.label), 9, _hoisted_19))
                  }), 128))
                ], 544), [
                  [_vModelSelect, $setup.selectedCameraId]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          ($setup.torchSupported)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_control_button, {
                  variant: $setup.torchOn ? ['blue'] : [],
                  onClick: _withModifiers($setup.toggleTorch, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.torchOn ? $setup.$t("Вимкнути ліхтарик") : $setup.$t("Увімкнути ліхтарик")), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ]))
            : _createCommentVNode("", true),
          ($setup.zoomSupported)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString($setup.$t("Зум")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "range",
                    min: $setup.zoomRange.min,
                    max: $setup.zoomRange.max,
                    step: $setup.zoomRange.step,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.zoomValue) = $event)),
                    onInput: $setup.applyZoom
                  }, null, 40, _hoisted_27), [
                    [
                      _vModelText,
                      $setup.zoomValue,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.result)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["event-scanner__overlay", `event-scanner__overlay--${$setup.overlayVariant}`]),
          onClick: _withModifiers($setup.scanNext, ["self"])
        }, [
          _createElementVNode("div", _hoisted_28, [
            ($setup.result.status === 'checked_in')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_29,
                  _createElementVNode("p", _hoisted_30, _toDisplayString($setup.$t("Учасника відмічено")), 1),
                  ($setup.result.fullName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString($setup.result.fullName), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : ($setup.result.status === 'already')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_32,
                    _createElementVNode("p", _hoisted_33, _toDisplayString($setup.$t("Вже відмічений")), 1),
                    ($setup.result.fullName)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString($setup.result.fullName), 1))
                      : _createCommentVNode("", true),
                    ($setup.result.checkInTime)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString($setup.formattedResultTime), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_36,
                    _createElementVNode("p", _hoisted_37, _toDisplayString($setup.$t("Невалідний QR")), 1),
                    ($setup.result.message)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString($setup.result.message), 1))
                      : _createCommentVNode("", true)
                  ], 64)),
            _createElementVNode("button", {
              class: "event-scanner__next",
              type: "button",
              onClick: _withModifiers($setup.scanNext, ["prevent"])
            }, _toDisplayString($setup.$t("Сканувати наступного")), 1)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}